import mapResponseCalendarsToData from '../mappers/mapResponseCalendarsToData'
import { IResponse } from './calendarsResponse'

export default async function(response: Response) {
  const json: IResponse = await response.json()

  return mapResponseCalendarsToData(json)
}
